export enum STORE_TYPES {
  GET_STORE_DATA = '@containerContext/GET_STORE_DATA',
  SET_STORE_DATA = '@containerContext/SET_STORE_DATA',
}

export interface Store {
  code: string;
  name: string;
}

export interface StoreContextState {
  stores: [];
  cpId?: number;
}
